"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarButtonStyles_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactbutton = require("@fluentui/react-button");
const useBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    vertical: {
        Beiy3e4: "f1vx9l62"
    },
    verticalIcon: {
        Be2twd7: "f1rt2boy",
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1s184ao"
    }
}, {
    d: [
        ".f1vx9l62{flex-direction:column;}",
        ".f1rt2boy{font-size:24px;}",
        [
            ".f1s184ao{margin:0;}",
            {
                p: -1
            }
        ]
    ]
});
const useToolbarButtonStyles_unstable = (state)=>{
    'use no memo';
    (0, _reactbutton.useButtonStyles_unstable)(state);
    const buttonStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(state.root.className, state.vertical && buttonStyles.vertical);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(state.icon.className, state.vertical && buttonStyles.verticalIcon);
    }
}; //# sourceMappingURL=useToolbarButtonStyles.styles.js.map
